"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var BulkImages_exports = {};
__export(BulkImages_exports, {
  default: () => BulkImages_default
});
module.exports = __toCommonJS(BulkImages_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10.1484 8.80469C10.1484 9.13021 10.0312 9.41016 9.79688 9.64453C9.57552 9.87891 9.30208 9.99609 8.97656 9.99609C8.65104 9.99609 8.37109 9.87891 8.13672 9.64453C7.90234 9.41016 7.78516 9.13021 7.78516 8.80469C7.78516 8.47917 7.90234 8.20573 8.13672 7.98438C8.37109 7.75 8.65104 7.63281 8.97656 7.63281C9.30208 7.63281 9.57552 7.75 9.79688 7.98438C10.0312 8.20573 10.1484 8.47917 10.1484 8.80469ZM16.457 15.5039L13.293 9.99609L10.8711 14.2344L9.36719 11.9492L7.00391 15.5039H16.457ZM5.16797 2.82812C4.59505 2.82812 4.10026 3.03646 3.68359 3.45312C3.27995 3.85677 3.07812 4.34505 3.07812 4.91797V14.0195C3.07812 14.5143 3.22786 14.9505 3.52734 15.3281C3.83984 15.7057 4.23047 15.9466 4.69922 16.0508C4.80339 16.5195 5.04427 16.9102 5.42188 17.2227C5.79948 17.5221 6.23568 17.6719 6.73047 17.6719H15.832C16.4049 17.6719 16.8932 17.4701 17.2969 17.0664C17.7135 16.6497 17.9219 16.1549 17.9219 15.582V6.48047C17.9219 5.98568 17.7656 5.54948 17.4531 5.17188C17.1536 4.79427 16.7695 4.55339 16.3008 4.44922C16.1966 3.98047 15.9557 3.59635 15.5781 3.29688C15.2005 2.98438 14.7643 2.82812 14.2695 2.82812H5.16797ZM15.4023 4.39062H6.73047C6.14453 4.39062 5.64974 4.59245 5.24609 4.99609C4.84245 5.39974 4.64062 5.89453 4.64062 6.48047V15.1523C4.43229 15.0612 4.25651 14.918 4.11328 14.7227C3.98307 14.5143 3.91797 14.2799 3.91797 14.0195V4.91797C3.91797 4.56641 4.03516 4.27344 4.26953 4.03906C4.51693 3.79167 4.81641 3.66797 5.16797 3.66797H14.2695C14.5299 3.66797 14.7578 3.73958 14.9531 3.88281C15.1615 4.01302 15.3112 4.18229 15.4023 4.39062ZM5.48047 6.48047C5.48047 6.12891 5.59766 5.83594 5.83203 5.60156C6.07943 5.35417 6.37891 5.23047 6.73047 5.23047H15.832C16.1836 5.23047 16.4766 5.35417 16.7109 5.60156C16.9583 5.83594 17.082 6.12891 17.082 6.48047V15.582C17.082 15.9336 16.9583 16.2331 16.7109 16.4805C16.4766 16.7148 16.1836 16.832 15.832 16.832H6.73047C6.37891 16.832 6.07943 16.7148 5.83203 16.4805C5.59766 16.2331 5.48047 15.9336 5.48047 15.582V6.48047Z",
      fill: "currentColor"
    }
  )
);
const SvgBulkImages = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var BulkImages_default = SvgBulkImages;
